import { buildJobHeaderData } from './jobConfig';

/*
 * Custom header config for Add Submission.
 * It fetches job form-groups through DetailHeaderCard's moduleName="job",
 * but renders a simpler job context card for the submission create flow.
 */
export const submissionJobConfig = {
  module: 'submissionJob',
  tabs: [],
  buildData: buildJobHeaderData,
};

export default submissionJobConfig;
